<template>
  <div class="order-link-person module" id="apply-info">
    <el-form class="" :model="form" :rules="rules" ref="linkPersonForm" label-width="165px"  label-position="right">
<!--      <el-form-item :prop="commonProps.isOiq? '' : 'businessCode'" label="请选择申请表类型" class="line-select">-->
<!--        <el-input style="width: 210px;" disabled v-if="commonProps.isOiq && commonProps.formInfo.orderBase" v-model="commonProps.formInfo.orderBase.businessName"></el-input>-->
<!--        <el-select v-model="form.businessCode" placeholder="请选择"-->
<!--                   v-else-->
<!--                   @change="lineChange"-->
<!--                   :disabled="disabledAll || hasLine || (!commonProps.isCreate && commonProps.formInfo.orderBase && commonProps.formInfo.orderBase.state > 11)"-->
<!--                   style="width: 210px;">-->
<!--          <el-option v-for="item in lineList" :key="item.platformCode" :label="item.configName" :value="item.platformCode">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <div class="module-label">
        申请方信息
        <template v-if="!isCs&&!loginSuccess">
          <el-button class="login-btn" type="primary" @click="dialogVisible = true">已有账号登录</el-button>
          <span class="login-tips">登录后，可导入上次申请表信息</span>
        </template>
      </div>
      <el-row class="apply-info-form" :gutter="37">
        <el-col :span="12">
          <el-form-item prop="companyNameCn" label="公司名称（中文）" :class="{ 'is-required': !isCs }">
            <el-popover placement="bottom-start" trigger="manual" v-model="titleTipsVisible" width="379" v-if="isCs">
              <div style="color:#ca4300;height:100px;">请输入至少3个文字，系统将自动匹配公司信息</div>
              <el-autocomplete slot="reference" :maxlength="150" style="width: 100%;" ref="autocomplete"
                               v-model="form.companyNameCn" :fetch-suggestions="querySearchAsync" @select="handleSelect" placeholder=""
                               highlight-first-item :trigger-on-focus="false" @focus="titleFocus" @blur="titleTipsVisible = false"
                               @input="titleFocus" :disabled="disabledAll" popper-class="company-popper">
                <template slot-scope="{ item }">
                  <div class="autocomplete-item">
                    <span class="autocomplete-item-name" v-html="item.customerNameCn || '空'"></span>
                    <span class="autocomplete-item-org">{{ item.siteInfo.map(v => v.organizationName).join(",")
                      }}</span>
                    <span class="autocomplete-item-address">{{ item.addressCn }}</span>
                    <span class="autocomplete-item-date">{{ item.createdDate }}</span>
                  </div>
                </template>
              </el-autocomplete>
            </el-popover>
            <el-input placeholder="" v-model="form.companyNameCn" maxlength="150" :disabled="disabledAll" v-else></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="companyAddressCn" label=" 公司地址（中文）" :class="{ 'is-required': !isCs }">
            <el-input placeholder="" v-model="form.companyAddressCn" maxlength="300" :disabled="disabledAll"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="companyNameEn" label="公司名称（英文） " :class="{ 'is-required': reportLuaCode && reportLuaCode !== 'ZN' && !isCs }">
            <el-input placeholder="" v-model="form.companyNameEn" maxlength="300" :disabled="disabledAll"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="companyAddressEn" label="公司地址（英文）" :class="{ 'is-required': reportLuaCode && reportLuaCode !== 'ZN' && !isCs }">
            <el-input placeholder="" v-model="form.companyAddressEn" maxlength="500" :disabled="disabledAll"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="divider"></div>
      <el-row class="link-info-form">
        <el-col :span="8">
          <el-form-item prop="linkPerson" label="申请方联系人">
            <el-input placeholder="" v-model="form.linkPerson" maxlength="20" :disabled="disabledAll || (linkDisabled&&commonProps.formInfo.application.linkPerson) || (isLogin&&!!userInfo.userName)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="linkPhone" label="手机号码">
            <el-input placeholder="" v-model="form.linkPhone" maxlength="50" :disabled="disabledAll || (linkDisabled&&commonProps.formInfo.application.linkPhone) || (isLogin&&!!userInfo.userPhone)"></el-input>
<!--            <div class="phone-tips">手机号将作为账号接收验证码</div>-->
            <el-tooltip class="item" effect="dark" content="手机号将作为账号接收验证码" placement="top" v-if="!isLogin">
              <img class="item-tips" src="../../assets/images/apply/tips.png" alt="">
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="linkEmail" label="电子邮箱">
            <el-input placeholder="" v-model="form.linkEmail" maxlength="200" :disabled="disabledAll || (linkDisabled&&commonProps.formInfo.application.linkEmail) || (isLogin&&!!userInfo.userEmail)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <el-button class="add-btn" @click="addCc" v-if="form.orderLinkList.length < 3 && !disabledAll" :disabled="disabledAll">+ 添加联系邮箱</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-for="(item, index) in form.orderLinkList" :key="index" class="link-info-form">
        <el-col :span="8">
          <el-form-item label="联系人姓名">
            <el-input placeholder="" v-model="item.linkName" maxlength="25" :disabled="disabledAll"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :prop="`orderLinkList.${index}.linkEmail`" label="电子邮箱" :rules="emailRule" class="is-required">
            <el-input placeholder="" v-model="item.linkEmail" maxlength="80" :disabled="disabledAll"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-button type="text" style="margin-left: 23px;" class="del-btn" @click="delCc(index)" :disabled="disabledAll" v-if="!disabledAll">删除</el-button>
        </el-col>
      </el-row>
    </el-form>
    <!--  登录即注册弹窗-->
    <el-dialog :visible.sync="dialogVisible"
               width="540px"
               :append-to-body='true'
               custom-class="apply-login"
               :close-on-press-escape="false"
               :close-on-click-modal="false">
      <login-merge
        :env="commonProps.env"
        :successCallback="loginEmit"
        :memberUrl="memberUrl"
        :parameter="parameter"></login-merge>
    </el-dialog>
  </div>
</template>

<script>
import { phoneReg, emailReg } from "utils";
import {host} from "src/config";
import LoginMerge from "src/components/loginMerge/index.vue";
import {qryBuLine, qryLabByLabCode} from "src/request/test";

export default {
  name: "ApplyInfo",
  components: {
    LoginMerge
  },
  props: {
    isCs: {
      type: Boolean,
      default: false
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    commonProps: {
      type: Object,
      default() {
        return {}
      }
    },
    disabledAll: {
      type: Boolean,
      default: false
    },
    linkDisabled: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    userInfo: {
      type: Object,
      default() {
        return {}
      },
    },
    loginSuccess: {
      type: Boolean,
      default: false
    },
    reportLuaCode: {
      type: String,
      default: ''
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value && !this.phoneReg.test(value)) {
        return callback(new Error('请输入正确的手机号'))
      } else {
        return callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('邮箱必填'))
      } else if (!this.emailReg.test(value)) {
        return callback(new Error('请输入正确的邮箱'))
      } else {
        return callback()
      }
    }
    const required = { required: true, message: '必填项' }
    return {
      dialogVisible: false,
      host: host(this.commonProps.env),
      emailReg,
      phoneReg,
      required,
      validatePhone,
      form: {
        companyNameCn: '',
        companyAddressCn: '',
        companyNameEn: '',
        companyAddressEn: '',
        linkPerson: '',
        linkEmail: '',
        linkPhone: '',
        verifyCode: '',
        orderLinkList: [],
        verifyType: 1,
        businessCode: ''
      },
      rules: {
        companyNameCn: [this.commonProps.required],
        companyAddressCn: [this.commonProps.required],
        companyNameEn: [this.commonProps.requiredEn, this.commonProps.validatorEn],
        companyAddressEn: [this.commonProps.requiredEn, this.commonProps.validatorEn],
        linkPerson: [required],
        linkEmail: [required, { validator: validateEmail }],
        linkPhone: [required, { validator: validatePhone }],
        verifyCode: [required],
        businessCode: [required],
      },
      phoneRule: [
        { validator: validatePhone }
      ],
      emailRule: [
        { validator: validateEmail }
      ],
      codeLoading: false,
      timer: null,
      seconds: 59,
      isCodeOpen: '1',
      captchaAppId: '192302431',
      verifyType: [
        { label: '短信验证码', value: 1 },
        { label: '邮箱验证码', value: 2 },
      ],
      orderNo: '',
      parameter:{
        regSource:'member',
        regMode: 'USER_REG'
      },
      memberUrl: '',
      titleTipsVisible: false,
      lineList: [],
      lineByCode: {},
      lineInit: false,
      lineQuery: false,
      hasLine: false,
      defaultBl: 'IND-ML'
    }
  },
  computed: {
    initQuery() {
      return this.lineInit
    }
  },
  watch: {
    initQuery: {
      handler(val) {
        if (val && this.commonProps.isCreate) {
          this.lineChange(this.form.businessCode)
        }
      }
    },
    'commonProps.formInfo': {
      handler(val, oldVal) {
        console.log(this.isCs, this.commonProps.isCreate);
        if (this.isCs && this.commonProps.isCreate) {
          console.log(111111);
          this.form.businessCode = this.commonProps.businessObj.platformCode
          this.$emit('qryBaseSample', this.form.businessCode)
          return;
        }
        if (!val || !val.orderBase || val === oldVal) {
          return;
        }
        console.log(22222);
        if (!this.commonProps.isCreate) {
          this.form.businessCode = val.orderBase.businessCode
          this.form.bu = val.orderBase.bu
          return
        }
        if (this.commonProps.isCreate && val.orderBase) {
          let ywx = this.$route.query.bl
          ywx = ywx ? ywx.toUpperCase() : ''
          const labCode = this.$route.query.lab
          this.form.businessCode = ywx || val.orderBase.businessCode
          this.form.bu = localStorage.getItem('bu') || val.orderBase.bu
          if (!ywx && labCode) {
            this.commonProps.apis.qryLabByLabCode({
              labCode
            }).then(res => {
              this.lineInit = true
              if (res.data && res.data.platformCode) {
                this.form.businessCode = res.data.platformCode
              }
            }).catch(e => {
              this.lineInit = true
            })
          } else {
            this.lineInit = true
          }
        }
      },
      immediate: true
    },
    data: {
      handler(val) {
        this.form = Object.assign(this.form, val)
        this.form.linkPerson = (val.linkPerson||'').slice(0, 20)
        this.$nextTick(() => {
          this.$refs.linkPersonForm && this.$refs.linkPersonForm.clearValidate()
        })
      },
      immediate: true,
      deep: true
    },
    $route: {
      handler(val) {
        this.orderNo = val.query.orderNo
      },
      immediate: true
    },
    'form.verifyType': {
      handler(val) {
        this.rules.linkPhone = val === 1 ? [this.required, { validator: this.validatePhone }] : [{ validator: this.validatePhone }]
      },
      immediate: true
    },
    form: {
      handler(val) {
        this.$emit('updateApplyInfo', val)
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    if (!this.isCs && !this.isLogin) {
      /* 引用腾讯盾SDK */
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = 'https://turing.captcha.qcloud.com/TCaptcha.js';
      document.body.appendChild(s);
    }
    this.memberUrl = location.origin
    // if (!this.commonProps.isOiq) {
    //   this.qryBuLine()
    // }
  },
  methods: {
    lineChange(val) {
      this.commonProps.apis.qryLineByLineCode({
        bu: '1001',
        lineCode: val
      }).then(res => {
        this.form.businessCode = res.data.platformCode
        this.form.bu = '1001'
        this.$emit('qryBaseSample', this.form.businessCode)
      }).catch(e => {
        console.log(e);
      })
      // if (!this.lineByCode[val]) {
      //   this.form.businessCode = this.defaultBl
      //   this.form.bu = localStorage.getItem('bu')
      //   this.$emit('qryBaseSample', val)
      //   return
      // }
      // if (this.$route.query.bl || this.$route.query.lab) this.hasLine = true
      // this.form.businessCode = val
      // this.form.bu = this.lineByCode[val].bu
      // this.$emit('qryBaseSample', val)
    },
    qryBuLine() {
      this.commonProps.apis.qryBuLine({bu: this.commonProps.bu}).then(res => {
        this.lineList = res.data.items.filter(v => {
          if (v.platformCode) {
            this.lineByCode[v.platformCode] = v
            return true
          }
        })
        this.lineQuery = true
      })
    },
    loginEmit() {
      this.dialogVisible = false
      this.$confirm('是否导入上一次填写的申请表内容到本次申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        showClose: false
      }).then(res => {
        location.reload()
      }).catch(e => {
        this.$emit('loginEmit')
      })
    },
    getValidate() {
      return new Promise(resolve => this.$refs.linkPersonForm.validate(resolve))
    },
    getData() {
      return JSON.parse(JSON.stringify(this.form))
    },
    delCc(index) {
      this.form.orderLinkList.splice(index, 1)
    },
    addCc() {
      this.form.orderLinkList.push({
        linkName: '',
        linkPhone: '',
        linkEmail: '',
      })
    },
    querySearchAsync(queryString, cb, isNo) {
      const queryLength = isNo ? 4 : 2
      if (queryString && queryString.length > queryLength) {
        const data = {}
        if (isNo) {
          data.taxRegistrationNumber = queryString
        } else {
          data.customerName = queryString
        }
        this.commonProps.apis.getCust(data).then(res => {
          if (res.data.items && res.data.items.length) {
            cb(res.data.items || [])
          } else {
            cb([])
          }
        }).catch(e => {
          cb([])
        })
      } else {
        cb([])
      }
    },
    handleSelect(item) { // 选中输入建议
      this.titleTipsVisible = false
      this.form.companyNameCn = item.customerNameCn
      this.form.companyAddressCn = item.addressCn
      this.form.companyNameEn = item.customerNameEn
      this.form.companyAddressEn = item.addressEn
    },
    titleFocus() {
      this.titleTipsVisible = !this.form.companyNameCn || this.form.companyNameCn.length < 3
    },
  }
}
</script>

<style scoped lang="scss">
.login-btn {
  width: 95px;
  height: 28px;
  padding: 0;
  line-height: 26px;
  margin: 0 22px;
}
.login-tips {
  color: rgb(255, 48, 48);
  font-size: 12px;
}
.line-select {
  ::v-deep .el-form-item__label {
    font-size: 16px;
    font-weight: 700;
  }
}
  .apply-info-form, .link-info-form {
    padding-right: 46px;
  }
  .order-link-person {
    .sub-title {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      line-height: 1;
      margin-bottom: 14px;
    }
    .del-btn {
      color: #878787;
    }
    .add-btn {
      width: 142px;
      height: 36px;
      background: #FFFFFF;
      border: 1px solid #CA4300;
      border-radius: 4px;
      font-size: 14px;
      color: #CA4300;
      line-height: 34px;
      padding: 0;
      background: rgba(255, 102, 0, 0.05);
    }
    .phone-item {
      .el-input__suffix-inner {
        .code-btn {
          min-width: 100px;
          text-align: center;
          cursor: pointer;
          background: #fff;
          font-size: 14px;
          color: #CA4300;
          line-height: 38px;
          display: inline-block;
          position: relative;
          padding: 0 10px 0 5px;
          &:before {
            content: "";
            position: absolute;
            width: 1px;
            height: 29px;
            background: #CA4300;
            left: -10px;
            top: 5px;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
.apply-login {
  border-radius: 12px !important;
  .el-form-item {
    margin-bottom: 22px;
    padding: 0;
    border: none;
  }
}


.apply-login .el-dialog__body {
  padding: 0 !important;
}

.apply-login .el-dialog {
  width: 850px !important;
  height: 575px !important;
  margin-top: 0 !important;
}

.apply-login .el-dialog__header {
  border-bottom: none !important;
}

.apply-login .login-wrap {
  display: flex !important;
  width: 850px !important;
  min-height: 400px !important;
}

.apply-login .login-wrap .login-text {
  width: 270px !important;
  height: 100% !important;
  background: #fff !important;
  border-left: 1px solid #ccc !important;
  padding: 50px 0px 15px 75px !important;
  margin-bottom: 20px !important;
}

.apply-login .login-wrap .login-text .title {
  margin-bottom: 15px !important;
}

.apply-login .login-wrap .login-text .logo {
  margin-bottom: 20px !important;
}

.apply-login .el-input__suffix-inner {
  font-size: 16px !important;
  font-family: Microsoft YaHei;
  font-weight: 400 !important;
  color: #CA4300 !important;
  margin-right: 22px !important;
  cursor: pointer !important;
}

.apply-login .link-color {
  color: inherit !important;
}
/* 登录弹窗个性化配置 */
.apply-login .login-components .login-module {
  width: 540px;
}
.apply-login .login-components .login-module .side {
  display: none;
}
/* 登录弹窗个性化配置 */
</style>